<div
  class="top-bar-categories flex align-items-center mb-3"
  [class.p-0]="innerWidth < 450"
  [class.ps-3]="innerWidth < 450"
  [class.ps-3]="innerWidth < 450"
>
  <div class="title flex align-items-center me-auto">
    <i _ngcontent-serverapp-c11="" class="fas fa-truck-moving me-3"></i>
    <h5>Lista de Precios</h5>
  </div>
  <div class="form-check form-switch me-3">
    <input
      type="checkbox"
      class="form-check-input"
      id="taxes"
      checked
      [disabled]="showLoading"
      (change)="showTaxes = !showTaxes"
      style="cursor: pointer"
    />
    <label
      class="form-check-label"
      for="taxes"
      style="cursor: pointer; margin-left: 10px"
      >{{
        showTaxes ? taxConfig.labelWithTax : taxConfig.labelWithoutTax
      }}</label
    >
  </div>
</div>

<div class="dashboard row m-0">
  <div class="lg:col-12 mb-3">
    <div class="card pt-3 px-0">
      <div
        class="card-body card-body-min-height-loading"
        [ngStyle]="{
          'min-height':
            precios && precios.length == 0 && !showLoading ? '40px' : '130px'
        }"
      >
        @if (showLoading) {
        <app-loading-element
          class="pt-3"
          [text]="'Cargando precios'"
        ></app-loading-element>
        } @if (precios && !precios.length) {
        <div class="row mt-3">
          <div class="col-12 text-center">
            No tiene una lista de precios acordada.
          </div>
        </div>
        }
        <div>
          <!-- Inicio Tabla primeng CRUD DIRECCIONES -->
          <ng-container>
            <p-table
              #dt
              [first]="first"
              [value]="precios"
              [rows]="rows"
              [paginator]="true"
              [loading]="loadingData"
              (onLazyLoad)="buscarPrecios($event)"
              [lazy]="true"
              [totalRecords]="totalRows"
              [rowsPerPageOptions]="[10, 25, 50]"
              dataKey="id"
              styleClass="p-datatable-striped p-datatable-sm"
              [tableStyle]="{ 'min-width': '15rem' }"
              currentPageReportTemplate="Mostrando {first} - {last} de {totalRecords} resultados"
              responsiveLayout="stack"
              [breakpoint]="'800px'"
            >
              <ng-template pTemplate="caption">
                <div class="flex justify-content-between">
                  <p-button
                    class="p-button-sm"
                    [outlined]="true"
                    icon="pi pi-filter-slash"
                    (onClick)="busqueda()"
                  />
                  <p-iconField
                    iconPosition="left"
                    class="ml-auto"
                    [ngClass]="{ 'w-4': !isMobile() }"
                  >
                    <p-inputIcon>
                      <i class="pi pi-search"></i>
                    </p-inputIcon>
                    <input
                      pInputText
                      type="text"
                      [(ngModel)]="searchValue"
                      class="w-100"
                      (keyup.enter)="busqueda($event)"
                      placeholder="Buscar"
                    />
                  </p-iconField>
                </div>
              </ng-template>
              <ng-template pTemplate="header">
                <tr>
                  <th>Nombre <p-sortIcon field="name"></p-sortIcon></th>
                  <th>Marca <p-sortIcon field="brand"></p-sortIcon></th>
                  <th>Código <p-sortIcon field="code"></p-sortIcon></th>
                  <th>Sku<p-sortIcon field="sku"></p-sortIcon></th>
                  <th>
                    Precio Público
                    <p-sortIcon field="price_public"></p-sortIcon>
                  </th>
                  <th>Precio <p-sortIcon field="price"></p-sortIcon></th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-precio>
                <tr>
                  <td
                    [ngClass]="{
                      'hidden p-0': !precio.name && isMobile(),
                      'p-1 border-bottom-1 border-solid border-gray-200':
                        precio.name
                    }"
                  >
                    <div class="p-column-title font-bold">Nombre</div>
                    <div class="md:col-12 col-6 p-0">
                      @if (!this.isMobile()) {
                      <a [routerLink]="root.product(precio.sku, precio.name)">
                        <img
                          class="precio-img lazyload"
                          [src]="root.getUrlImagenMiniatura(precio)"
                          [alt]="precio.name"
                        />
                      </a>
                      }
                      {{ precio.name | titlecase }}
                    </div>
                  </td>
                  <td
                    [ngClass]="{
                      'hidden p-0': !precio.brand && isMobile(),
                      'p-1 border-bottom-1 border-solid border-gray-200':
                        precio.brand
                    }"
                  >
                    <div class="p-column-title font-bold">Marca</div>
                    <div class="md:col-12 col-6 p-0">
                      {{ precio.brand }}
                    </div>
                  </td>
                  <td
                    [ngClass]="{
                      'hidden p-0': !precio.customerCode && isMobile(),
                      'p-1 border-bottom-1 border-solid border-gray-200':
                        precio.customerCode
                    }"
                  >
                    <div class="p-column-title font-bold">Código</div>
                    <div class="md:col-12 col-6 p-0">
                      {{ precio.customerCode }}
                    </div>
                  </td>
                  <td
                    [ngClass]="{
                      'hidden p-0': !precio.sku && isMobile(),
                      'p-1 border-bottom-1 border-solid border-gray-200':
                        precio.sku
                    }"
                  >
                    <div class="p-column-title font-bold">Sku</div>
                    <div class="md:col-12 col-6 p-0">
                      {{ precio.sku }}
                    </div>
                  </td>
                  <td
                    [ngClass]="{
                      'hidden p-0': !precio.commonPrice && isMobile(),
                      'p-1 border-bottom-1 border-solid border-gray-200':
                        precio.commonPrice
                    }"
                  >
                    <div class="p-column-title font-bold">Precio normal</div>
                    <div class="md:col-12 col-6 p-0 line-through">
                      {{
                        showTaxes
                          ? (precio.commonPrice | currency)
                          : (precio.commonPriceBruto | currency)
                      }}
                      {{
                        showTaxes
                          ? taxConfig.labelWithTax
                          : taxConfig.labelWithoutTax
                      }}
                    </div>
                  </td>
                  <td
                    [ngClass]="{
                      'hidden p-0': !precio.price && isMobile(),
                      'p-1 border-bottom-1 border-solid border-gray-200':
                        precio.price,
                      'border-gray-400 border-bottom-3': isMobile()
                    }"
                  >
                    <div class="p-column-title font-bold">Precio dscto.</div>
                    <div class="md:col-12 col-6 p-0 text-red-500">
                      {{
                        showTaxes
                          ? (precio.price | currency)
                          : (precio.priceBruto | currency)
                      }}
                      {{
                        showTaxes
                          ? taxConfig.labelWithTax
                          : taxConfig.labelWithoutTax
                      }}
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </ng-container>

          <!-- Fin Tabla primeng CRUD  -->
        </div>
      </div>
    </div>
  </div>
</div>
